import axios from "../../utils/Axios";

// get All recods from database

export const getAllTransactions = async (
  searchTerm,
  transactionType,
  order,
  limit,
  start,
  balanceRequired
) => {
  let balance;
  if (balanceRequired) {
    const resultToCalculateBalance = await axios.get(`/transactions`);
    balance = resultToCalculateBalance.data.reduce((acc, t) => {
      if (t.type === "expense") acc = acc - t.amount;
      if (t.type === "income") acc = acc + t.amount;
      return acc;
    }, 0);
  }
  let queryString = "";
  queryString += order ? `_sort=id&_order=${order}` : `_sort=id&_order=desc`;
  if (limit) queryString += `&_limit=${limit}`;
  queryString += start ? `&_start=${start}` : `&_start=0`;
  queryString +=
    transactionType === "expense" || transactionType === "income"
      ? `&type=${transactionType}`
      : ``;
  if (searchTerm) queryString += `&name_like=${searchTerm}`;
  const result = await axios.get(`/transactions?${queryString}`);

  return {
    data: result.data,
    noOfTotalRecords: result.headers["x-total-count"],
    balance: balance || 0,
  };
};

//add a record in database

export const addTransaction = async (data) => {
  const result = await axios.post("/transactions", data);
  return result.data;
};

//edit a record in database

export const editTransaction = async (data, id) => {
  const result = await axios.patch(`/transactions/${id}`, data);
  return result.data;
};

//delete a record from database

export const deleteTransaction = async (id) => {
  const result = await axios.delete(`/transactions/${id}`);
  console.log(result);
  return result.data;
};
